// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1_mVc","content":"Consent_content__2VdOw","footer":"Consent_footer__1UnvG"};